import { Component } from "@angular/core"
import { FormGroup, FormControl, Validators } from "@angular/forms"
import { Router } from "@angular/router"
import { ToastrService } from "ngx-toastr"
import { AuthService } from "src/app/services/actions/auth.service"
import { UserService } from "src/app/services/user.service"
import { ValidarCpf } from '../../helpers/validate-cpf'
import countryCodes from '../../../enums/country-codes'
import fusos from '../../../enums/fusos'
import crpStates from '../../../enums/crp-states'

@Component({
	selector: "app-cadastro",
	templateUrl: "./cadastro.component.html",
	styleUrls: ["./cadastro.component.scss"],
})
export class CadastroComponent {

	submitted = false;
	signingUp: Boolean
	invalidCpf: Boolean
	hideCrp: Boolean = false
	fusos = fusos

	cadastroForm = new FormGroup({
		name: new FormControl('', Validators.required),
		crpState: new FormControl(''),
		whatsApp: new FormControl('', Validators.required),
		cpf: new FormControl('', Validators.required),
		crp: new FormControl(''),
		tipoProfissional: new FormControl('Psicólogo', Validators.required),
		email: new FormControl('', [Validators.required, Validators.email]),
		password: new FormControl('', [Validators.required, Validators.minLength(8)]),
		checkAceito: new FormControl(''),
		ondeNosConheceu: new FormControl('', Validators.required),
		countryCode: new FormControl('55', Validators.required),
		fusoHorario: new FormControl('-3.00', Validators.required),
	});

	get formField () {
		return this.cadastroForm.controls
	}

	countryCodes = countryCodes
	crpStatesList: Array<any> = crpStates
	ondeNosConheceu = [
		'Google',
		'LinkedIn',
		'Facebook',
		'Instagram',
		'Indicação',
		'Youtube',
		'Panfleto',
		'Outros'
	]

	constructor(
		private toastr: ToastrService,
		private router: Router,
		private authService: AuthService,
		private userService: UserService,
	) {}

	cadastrar () {
		this.submitted = true

		if (this.cadastroForm.invalid) {
			this.toastr.warning("Dados incorretos no formulário.", "Atenção")
			return
		}

		let userValues = this.cadastroForm.getRawValue()
		
		if (!ValidarCpf.cpf(userValues["cpf"])) {
			this.invalidCpf = true
			this.toastr.warning("CPF inválido", "Atenção")
			return
		}

		this.invalidCpf = false

		userValues.cellphone = userValues.countryCode + userValues.whatsApp;
		userValues.whatsApp = userValues.countryCode + userValues.whatsApp;
		userValues.crp = userValues.crpState + userValues.crp;

		delete userValues.crpState

		this.cadastroForm.disable();
		this.signingUp = true

		this.authService.newUser(userValues).subscribe(
			(res) => {
				this.toastr.success("Cadastro efetuado! Entraremos em contato em breve", "Sucesso");
				const userLogin = {
					userLogin: userValues['email'],
					password: userValues["password"]
				}
				this.login(userLogin)
				this.signingUp = false
				return
			},
			(err) => {
				console.log(err);
				this.signingUp = false
				this.cadastroForm.enable();
				this.toastr.warning("Dados já cadastrados", "Volte ao início para redefinir a senha");
			}
		);
	}

	login (userValues) {
		this.authService.login(userValues).subscribe(
			(res) => {
				this.userService.setUser(res["user"])
				this.router.navigate(["logado"], { queryParams: { newUser: true } })
			},
			(err) => {
				if (err.status == 401) {
					this.toastr.warning('Usuário inválido.', "Atenção");
				} else {
					this.router.navigate(["logado"])
				}
			}
		);
	}

	onOptionsSelected(value: any){
		if (value === 'Psicanalista') return this.hideCrp = true;
		this.hideCrp = false;
	}

	voltar () {
		window.history.back()
	}
}
